export default "__VITE_ASSET__BWpneMqX__"